import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 4h-10v16h10","key":"svg-0"}],["path",{"d":"M7 12l8 0","key":"svg-1"}]]

const IconLetterE = createReactComponent('outline', 'letter-e', 'LetterE', __iconNode);

export default IconLetterE;